export default __webpack_public_path__ + "static/media/robots.5d1287d7.png";